//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  components: {
  },
  props: {
    visibleList: {
      type: Array,
      default: () => []
    },
    downloadList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      hrefLink: '',
      linkAddress: {},
      downmenu: [{
        logo: 'https://resources.interface003.com/web20/img/head/windows-icon.png',
        title: 'PC Client',
        des: '全球监管查询桌面版',
        link: '',
        ewm: '',
        bj: 'whty', // 背景色
        label: 'https://resources.interface003.com/web20/img/head/windows-ico.svg'
      }, {
        logo: 'https://resources.interface003.com/web20/img/head/android-icon.png',
        title: '外汇天眼安卓版', // 标题
        des: '全球监管查询APP',
        link: '', // 下载链接
        ewm: '',
        bj: 'wkfx',
        label: 'https://resources.interface003.com/web20/img/head/android-ico.svg'
      }, {
        logo: 'https://resources.interface003.com/web20/img/head/ios-icon.svg', // logo
        title: '', // 标题
        des: '全球监管查询APP',
        link: '', // 下载链接
        ewm: '',
        bj: 'jjb',
        label: 'https://resources.interface003.com/web20/img/commen/ttt.svg'
      }],
      menuList: [], // 菜单处理
      androidApk: null,
      iosUrl: null
    }
  },
  created () {
    // this.getDownloadList()
  },
  mounted () {
    this.setMenu()
    this.getDownloadList()
    // this.hrefLink = `${window.location.host}/${this.$store.state.LanguageCode}/donwload.html`
  },
  methods: {
    abBrokerDomain (url) {
      // const keywords = ['privacy.html', '/news.html', '/newsdetail/', 'original.html', 'industry.html', 'brokernews.html', 'wikilist.html', 'evaluation.html', 'authority.html']
      const keywords = []
      return keywords.some(keyword => url.includes(keyword))
    },
    jumpLink (link) {
      console.log('link: ', link)
      if (link) {
        location.href = link
      }
    },
    setMenu () { // 处理菜单item.code == 'menu_home'
    // 处理菜单item.code == 'menu_home'
      const menu = []
      const newSonMenu = []
      const deleteArr = [] // 索引
      // const videoSonMenu = []
      let copyArr = JSON.parse(JSON.stringify(this.visibleList))
      const menuNewIdx = copyArr?.findIndex(x => x.code === 'menu_news')
      // const menuVideoIdx = copyArr?.findIndex((x) => x.code === 'menu_video')
      // 倒序遍历数组（从最后一项开始）
      if (menuNewIdx > -1) {
        for (let i = copyArr.length - 1; i >= 0; i--) {
          const x = copyArr[i]
          if (x.code === 'menu_calendar' || x.code === 'menu_kx') {
            x.father = x.code
            newSonMenu.unshift(x)
            deleteArr.push(i)
          }
        }
        copyArr[menuNewIdx].submenus = [...copyArr[menuNewIdx].submenus, ...newSonMenu]
      }
      // console.log(menuVideoIdx, 'ffdsffffffff')
      // if (menuVideoIdx > -1) {
      //   for (let i = copyArr.length - 1; i >= 0; i--) {
      //     const x = copyArr[i]
      //     if (x.code === 'menu_liveroom') {
      //       x.father = x.code
      //       videoSonMenu.unshift(x)
      //       deleteArr.push(i)
      //     }
      //   }
      //   copyArr[menuVideoIdx].submenus = [...copyArr[menuVideoIdx].submenus, ...videoSonMenu]
      // }
      copyArr = copyArr?.filter((x, idx) => !deleteArr.includes(idx))
      copyArr.forEach((item, i) => {
        if (item.submenus.length > 0) this.menuList.push(item)
        else if (item.code != 'menu_home' && item.submenus.length == 0) {
          item.father = item.code
          menu.push(item)
        }
      })
      const arr = {
        code: 'menu_other',
        name: '其它',
        key: '20849',
        url: '/',
        submenus: [...menu]
      }
      this.menuList.push(arr)
    },
    async getDownloadList () {
      await this.$api.download.homeClientInit().then((res) => {
        res.forEach((el) => {
          if (el.Type == 1) {
            // 国内apk
            this.linkAddress.FXEYEapk = el.LinkAddress
          }
          if (el.Type == 2) {
            // 国外apk
            this.linkAddress.WikiFXapk = el.LinkAddress
          }
          if (el.Type == 3) {
            // ios国内
            this.linkAddress.fxeyeIOS = el.LinkAddress
          }
          if (el.Type == 4) {
            // ios 国外
            this.linkAddress.wikifxIOS = el.LinkAddress
          }
          if (el.Type == 5) {
            // 谷歌
            this.linkAddress.playGoogle = el.LinkAddress
          }
          if (el.Type == 6) {
            // pc
            this.linkAddress.fxeyePC = el.LinkAddress
          }
          if (el.Type == 7) { // *国内ios全球
            this.linkAddress.FXeye_golbal_ios = el.LinkAddress
          }
        })
        if (this.$store.state.isWiki == '1') {
          this.downmenu[1].title = 'WikiFX Android'
          this.downmenu[2].title = 'WikiFX IOS'
          this.androidApk = this.linkAddress.WikiFXapk
        } else if (this.$store.state.isWiki == '2' || this.$store.state.isWiki == '4') {
          this.androidApk = this.linkAddress.FXEYEapk
          this.downmenu[1].title = 'Fxeye Android'
          this.downmenu[2].title = 'Fxeye IOS'
        } else if (this.$store.state.isWiki == '3') {
          if (this.$store.state.myCountry.toLowerCase() == 'cn') {
            this.downmenu[1].title = 'Fxeye Android'
            this.downmenu[2].title = 'Fxeye IOS'
          } else {
            this.downmenu[1].title = 'WikiFX Android'
            this.downmenu[2].title = 'WikiFX IOS'
          }
          this.androidApk = this.linkAddress.FXEYEapk
        }
        this.downmenu[0].link = this.linkAddress.fxeyePC
        this.downmenu[1].ewm = this.hrefLink
        this.downmenu[2].ewm = this.hrefLink
      }).catch(() => {
        // console.log('downloadInit,接口错误')
      })
    }
  }
}
